import { showNotification } from "@mantine/notifications";
import { useToggleContractIngestionMutation } from "../APIs/Aws.api";
import AsyncToggle from "./reusable/AsyncToggle";
import { IconX } from "@tabler/icons";
import { useEffect } from "react";

const ContractTrackingToggle = ({ contractId, enabled, onCompleted }) => {
  const [toggleContract, { isLoading: pendingToggle, error }] =
    useToggleContractIngestionMutation();

  const onToggleError = (e) => {
    return showNotification({
      id: "toggle-contract-ingestion",
      icon: <IconX />,
      autoClose: 4000,
      color: "red",
      title: `Failed to toggle the contract ingestion`,
      message: e.reason || e.message,
      loading: false
    });
  };

  const handleToggleContract = async (value) => {
    try {
      await toggleContract({ contractId, disabled: value });
      onCompleted();
    } catch (e) {
      console.error(e);
      return onToggleError(e);
    }
  };

  useEffect(() => {
    if (error?.error) onToggleError({ message: error.error });
  }, [error]);

  return (
    <AsyncToggle
      label="Contract tracking"
      value={enabled}
      onChange={(e) => handleToggleContract(!e.target.checked)}
      loading={pendingToggle}
    />
  );
};

export default ContractTrackingToggle;
